export default __webpack_public_path__ + "static/media/elevate-lav-poster-2.c2a7c221.jpg";